export const NAME = 'NAME' as const;
export const DESCRIPTION = 'DESCRIPTION' as const;
export const LEAD = 'LEAD' as const;
export const ISSUES = 'ISSUES' as const;

export const ORDER_FIELDS = {
	[NAME]: 'name',
	[DESCRIPTION]: 'description',
	[LEAD]: 'lead',
	[ISSUES]: 'issueCount',
} as const;
